import { Browser } from "./Frames";

export const TIERS = [
  { key: "classico", name: "Classico", price: 35, items: "Sfogliatelle, roccocò, mostaccioli" },
  { key: "premium", name: "Premium", price: 55, items: "Panettone artigianale, babà in vasocottura, liquore" },
  { key: "luxury", name: "Luxury", price: 80, items: "Linea Luxury, limoncello, cofanetto blu e oro" },
];

const fmt = (n) => "€ " + Math.round(n).toLocaleString("it-IT", { useGrouping: "always" });

export function quote(tierKey, qty, logo) {
  const unit = TIERS.find((t) => t.key === tierKey).price + (logo ? 2 : 0);
  const sub = unit * qty;
  const rate = qty >= 100 ? 0.1 : qty >= 50 ? 0.05 : 0;
  return { unit, sub, disc: sub * rate, rate, total: sub * (1 - rate) };
}

const TierCard = ({ t, on }) => (
  <div className={`tier ${on ? "tier--on" : ""}`}>
    <img src="/images/cesto_sm.jpg" alt="" className={`w-full h-20 object-cover rounded-md ${t.key === "classico" ? "grayscale-[35%]" : ""}`} />
    <div className="flex flex-wrap justify-between items-baseline gap-x-2 mt-2">
      <span className="font-display text-[15px] text-navy">{t.name}</span>
      <span className="text-[12px] font-semibold text-[var(--gold)]">{fmt(t.price)}</span>
    </div>
    <div className="text-[10px] text-[var(--ink-soft)] leading-snug mt-0.5">{t.items}</div>
  </div>
);

const Row = ({ l, v, strong }) => (
  <div className={`flex justify-between text-[11.5px] py-1.5 ${strong ? "font-semibold text-navy border-t border-[rgba(176,141,87,0.5)] mt-1 pt-2.5" : ""}`}>
    <span>{l}</span><span>{v}</span>
  </div>
);

export const PortalMock = ({ tier = "premium", qty = 40, logo = true, company = "Studio Ferraro & Associati", testId }) => {
  const q = quote(tier, qty, logo);
  return (
    <Browser testId={testId}>
      <div className="portal">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--gold)]">Strenne aziendali · Natale 2027</div>
          <div className="font-display text-[20px] text-navy mt-1 mb-3">Configura il regalo per il tuo team</div>
          <div className="label-sm">1 · Scegli il cesto (prezzo per dipendente)</div>
          <div className="grid grid-cols-3 gap-2.5">
            {TIERS.map((t) => <TierCard key={t.key} t={t} on={t.key === tier} />)}
          </div>
          <div className="grid grid-cols-2 gap-2.5 mt-3">
            <div>
              <div className="label-sm">2 · Personalizza</div>
              <div className={`field ${logo ? "field--on" : ""}`}><span><i className={`check ${logo ? "" : "check--off"}`}>{logo && <svg viewBox="0 0 10 10" width="9" height="9"><path d="M1.5 5.2 4 7.5 8.5 2.5" fill="none" stroke="#fff" strokeWidth="1.8" /></svg>}</i>Biglietto e nastro con il vostro logo</span><span className="whitespace-nowrap">+ € 2</span></div>
            </div>
            <div>
              <div className="label-sm">3 · Quantità e consegna</div>
              <div className="field"><span>Dipendenti</span><span className="font-display text-[16px] text-navy" data-testid={testId && `${testId}-qty`}>{qty}</span></div>
            </div>
          </div>
          <div className="text-[10px] text-[var(--ink-soft)] mt-2">Consegna in sede in provincia di Salerno inclusa · data a scelta dal 1° dicembre</div>
        </div>
        <div className="quote">
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--gold)]">Preventivo immediato</div>
          <div className="text-[11px] text-[var(--ink-soft)] mb-2 mt-1">{company}</div>
          <Row l={`${qty} × ${fmt(q.unit)}`} v={fmt(q.sub)} />
          <Row l={q.rate ? `Sconto volume ${q.rate * 100}%` : "Sconto volume (da 50 pz)"} v={q.rate ? `– ${fmt(q.disc)}` : "–"} />
          <Row l="Consegna" v="Inclusa" />
          <Row strong l="Totale IVA esclusa" v={<span data-testid={testId && `${testId}-total`}>{fmt(q.total)}</span>} />
          <div className="app-cta mt-3">Conferma e blocca la data</div>
          <div className="text-[9.5px] text-center text-[var(--ink-soft)] mt-2">Prezzo valido 15 giorni · fattura elettronica</div>
        </div>
      </div>
    </Browser>
  );
};
